import { render, staticRenderFns } from "./HelloNovel.vue?vue&type=template&id=57dc7e61&scoped=true&"
import script from "./HelloNovel.vue?vue&type=script&lang=js&"
export * from "./HelloNovel.vue?vue&type=script&lang=js&"
import style0 from "./HelloNovel.vue?vue&type=style&index=0&id=57dc7e61&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dc7e61",
  null
  
)

export default component.exports